import propTypes from 'prop-types';
import Form from './Form';

CreateForm.propTypes = {
  handleClick: propTypes.func.isRequired,
  refetch: propTypes.func.isRequired
};

export default function CreateForm({handleClick, refetch}) {
  return (
    <div className="card container my-2" style={{backgroundColor: '#e6eae6'}}>
      <div className="card-body p-2">
        <Form handleClose={handleClick} refetch={refetch} />
      </div>
    </div>
  );
}
